
import { LogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'
import EditButton from '../buttons/EditButton.vue'
import CancelButton from '../buttons/CancelButton.vue'
import DangerButton from '../buttons/DangerButton.vue'
import EditFrame from '../EditFrame.vue'
import LogList from '../log/LogList.vue'

@Component({
  components: {
    EditFrame,
    EditButton,
    CancelButton,
    DangerButton,
    LogList
  }
})
export default class TinyLog extends Vue {
  @Prop({
    default: 1
  })
  deviceNumber!: number

  @Prop()
  stationId!: string

  @Prop({
    default: () => [] as LogEntry[]
  })
  logEntries!: LogEntry[]

  get filteredLogEntries (): LogEntry[] {
    return this.logEntries.filter(
      (logEntry) => (logEntry.payload as any).device === this.deviceNumber
    )
  }
}
